module.exports = __webpack_public_path__ + "static/media/car-bus.928f5dcd.svg";